import { apiSlice } from "./apiSlice";

export const globusApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        bindGlobusIdToUser: builder.mutation({
            query: (requestParams) => {
                return {
                    url: `/globus/${requestParams.username}`,
                    method: 'PATCH',
                    body: requestParams.body
                }
            },
        })
    })
});

export const {
    useBindGlobusIdToUserMutation
} = globusApiSlice;

